import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/brand-logo";
import { ThemeToggle } from "@/components/theme-toggle";
import { LanguageToggle } from "@/components/language-toggle";
import { useLanguage } from "@/components/language-provider";
import { ArrowLeft } from "lucide-react";
import { AnimatedSection } from "@/components/landing/animations";

export function LegalLayout({ title, children }: { title: string; children: React.ReactNode }) {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background/85 backdrop-blur-lg border-b">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Link href="/"><Button variant="ghost" size="sm" className="gap-2 rounded-full"><ArrowLeft className="w-4 h-4" />{language === "pt" ? "Voltar" : "Back"}</Button></Link>
              <BrandLogo size="sm" animated={false} />
            </div>
            <div className="flex items-center gap-2"><LanguageToggle /><ThemeToggle /></div>
          </div>
        </div>
      </header>

      <section className="section-padding">
        <div className="container mx-auto px-4">
          <AnimatedSection>
            <article className="max-w-3xl mx-auto prose prose-neutral dark:prose-invert prose-headings:font-display prose-headings:font-normal prose-a:no-underline hover:prose-a:underline" style={{ "--tw-prose-links": "var(--fs-forest)" } as any}>
              <h1 className="text-4xl md:text-5xl font-display mb-8 not-prose">{title}</h1>
              {children}
            </article>
          </AnimatedSection>
        </div>
      </section>

      <footer className="py-8 border-t text-center text-sm text-muted-foreground">
        <div className="container mx-auto px-4">© {new Date().getFullYear()} FillSign.</div>
      </footer>
    </div>
  );
}
